"use client";

import { c as _c } from "react/compiler-runtime";
import { useKeyPressEvent } from "react-use";
import { useCallback, useEffect, useRef, useState } from "react";
import { MentionTypeaheadOption } from "./MentionsPlugin";
import MentionsTypeaheadMenuItem from "./MentionsTypeaheadMenuItem";
export default function MentionsTypeaheadMenu(t0) {
  const $ = _c(22);
  const {
    selectedIndex,
    options,
    setHighlightedIndex,
    selectOptionAndCleanUp
  } = t0;
  const menuRef = useRef(null);
  const [position, setPosition] = useState("bottom");
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      if (menuRef.current) {
        const rect = menuRef.current.getBoundingClientRect();
        const spaceAbove = rect.top;
        const spaceBelow = window.innerHeight - rect.bottom;
        setPosition(spaceBelow >= spaceAbove ? "bottom" : "top");
      }
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const updatePosition = t1;
  let t2;
  let t3;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      updatePosition();
      window.addEventListener("resize", updatePosition);
      return () => window.removeEventListener("resize", updatePosition);
    };
    t3 = [updatePosition];
    $[1] = t2;
    $[2] = t3;
  } else {
    t2 = $[1];
    t3 = $[2];
  }
  useEffect(t2, t3);
  let t4;
  if ($[3] !== options || $[4] !== selectOptionAndCleanUp || $[5] !== selectedIndex || $[6] !== setHighlightedIndex) {
    t4 = () => {
      if (typeof selectedIndex === "number" && options.length > 0) {
        setHighlightedIndex(selectedIndex);
        selectOptionAndCleanUp(options[selectedIndex]);
      }
    };
    $[3] = options;
    $[4] = selectOptionAndCleanUp;
    $[5] = selectedIndex;
    $[6] = setHighlightedIndex;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  useKeyPressEvent(" ", t4);
  const t5 = `tailwind-scope tw-absolute tw-z-50 tw-w-[20rem] tw-rounded-lg tw-shadow-xl tw-bg-iron-800 tw-ring-1 tw-ring-black tw-ring-opacity-5 tw-p-2 ${position === "top" ? "tw-bottom-full tw-mb-1" : "tw-top-full tw-mt-1"}`;
  let t6;
  if ($[8] !== options || $[9] !== selectOptionAndCleanUp || $[10] !== selectedIndex || $[11] !== setHighlightedIndex) {
    let t7;
    if ($[13] !== selectOptionAndCleanUp || $[14] !== selectedIndex || $[15] !== setHighlightedIndex) {
      t7 = (option, i) => <MentionsTypeaheadMenuItem index={i} isSelected={selectedIndex === i} onClick={() => {
        setHighlightedIndex(i);
        selectOptionAndCleanUp(option);
      }} onMouseEnter={() => {
        setHighlightedIndex(i);
      }} key={option.key} option={option} />;
      $[13] = selectOptionAndCleanUp;
      $[14] = selectedIndex;
      $[15] = setHighlightedIndex;
      $[16] = t7;
    } else {
      t7 = $[16];
    }
    t6 = options.map(t7);
    $[8] = options;
    $[9] = selectOptionAndCleanUp;
    $[10] = selectedIndex;
    $[11] = setHighlightedIndex;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[17] !== t6) {
    t7 = <ul className="tw-flex tw-flex-col tw-px-2 tw-mx-0 tw-mb-0 tw-list-none">{t6}</ul>;
    $[17] = t6;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  let t8;
  if ($[19] !== t5 || $[20] !== t7) {
    t8 = <div ref={menuRef} className={t5}>{t7}</div>;
    $[19] = t5;
    $[20] = t7;
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  return t8;
}